<template>
  <div class="sel-modal clearfix">
    <div class="sel-modal-header clearfix">
      <vxe-radio-group v-model="selectTab">
        <ul class="tab-list">
          <li v-if="type !== 2">
            <vxe-radio name="xtabs" label="tab1">船舶列表</vxe-radio>
          </li>
          <li v-if="type !== 1">
            <vxe-radio name="xtabs" label="tab2">车辆列表</vxe-radio>
          </li>
        </ul>
      </vxe-radio-group>
      <div class="search-box" style="display: flex;align-items: center">
        <vxe-input v-if="selectTab === 'tab1'"
                   style="height: 34px !important;border: 1px solid #dcdee2;margin-right: 10px;" v-model="mmsi"
                   type="search" placeholder="搜索MMSI" @keyup.enter.native="search" @search-click="search"></vxe-input>
        <vxe-input style="height: 34px !important;border: 1px solid #dcdee2;" v-model="name" type="search"
                   :placeholder="selectTab === 'tab2' ? '搜索车牌号':'搜索船名'" @keyup.enter.native="search"
                   @search-click="search"></vxe-input>
        <Button type="primary" icon="ios-add" style="margin-left: 10px;"
                v-if="isHavePermission('car:createCar') && selectTab === 'tab2'"
                @click="showCarModal">新建车辆信息
        </Button>
        <Button type="primary" icon="ios-add" style="margin-left: 10px;"
                v-if="isHavePermission('ship:createShip') && selectTab === 'tab1'"
                @click="showShipModal">新建船舶信息
        </Button>
      </div>
    </div>
    <div v-show="selectTab === 'tab1'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable1"
          class="table-style"
          max-height="430"
          align="center"
          :auto-resize="true"
          :data="shipData"
          :loading="loading1"
          @current-change="currentChangeEvent1"
      >
        <vxe-table-column field="id" title="序号"></vxe-table-column>
        <vxe-table-column field="shipName" title="船名" width="150"></vxe-table-column>
        <vxe-table-column field="mmsi" title="MMSI"></vxe-table-column>
        <vxe-table-column field="deadweight" title="载重吨"></vxe-table-column>
        <vxe-table-column field="shipType" title="船舶种类"></vxe-table-column>
        <!--        <vxe-table-column field="homePortText" title="船籍港"></vxe-table-column>-->
        <!--        <vxe-table-column field="shipLength" title="船长(m)"></vxe-table-column>-->
        <!--        <vxe-table-column field="shipWidth" title="船宽(m)"></vxe-table-column>-->
        <!--        <vxe-table-column field="totalweight" title="总吨"></vxe-table-column>-->
        <!--        <vxe-table-column field="netweight" title="净吨"></vxe-table-column>-->
        <!--        <vxe-table-column field="loadDraught" title="满载吃水(m)">-->
        <!--        </vxe-table-column>-->
        <!--        <vxe-table-column field="buildTime" title="建造时间">-->
        <!--          <template slot-scope="{ row }">-->
        <!--            <span>{{row.buildTime | timeFormatDate}}</span>-->
        <!--          </template>-->
        <!--        </vxe-table-column>-->
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page1.currentPage"
          :page-size.sync="page1.pageSize"
          :total="page1.totalResult"
          @page-change="changePage1"
      ></vxe-pager>
    </div>
    <div v-show="selectTab === 'tab2'">
      <vxe-table
          show-overflow
          stripe
          highlight-current-row
          highlight-hover-row
          border="none"
          ref="xTable2"
          class="table-style"
          height="430"
          align="center"
          :auto-resize="true"
          :data="carData"
          :loading="loading2"
          @current-change="currentChangeEvent2"
      >
        <vxe-table-column field="id" title="序号" width="100"></vxe-table-column>
        <vxe-table-column field="carNum" title="车牌号"></vxe-table-column>
        <vxe-table-column field="carType" title="车辆类型"></vxe-table-column>
        <vxe-table-column field="deadweight" title="核定载质量（吨）"></vxe-table-column>
        <vxe-table-column field="carColor" title="车牌颜色"></vxe-table-column>
        <!--        <vxe-table-column field="owner" title="车辆所有人"></vxe-table-column>-->
        <!--        <vxe-table-column field="transportCardNum" title="车辆道路运输证号"></vxe-table-column>-->
        <!--        <vxe-table-column field="archivesNum" title="车辆行驶证档案编号"></vxe-table-column>-->
      </vxe-table>
      <vxe-pager
          background
          size="small"
          :current-page.sync="page2.currentPage"
          :page-size.sync="page2.pageSize"
          :total="page2.totalResult"
          @page-change="changePage2"
      ></vxe-pager>
    </div>
    <vxe-modal class="createCarShipModal" v-model="createCarVisible" title="新增车辆信息" width="1400" height="860"
               @close="closeCar" resize
               position="center">
      <create-car-modal @afterSave="closeCarModal" ref="modalCar" @close="closeCar"></create-car-modal>
    </vxe-modal>
    <vxe-modal class="createCarShipModal" v-model="createShipVisible" title="新增船舶信息" width="1400" height="900"
               @close="closeShip" resize
               position="center"
               destroy-on-close>
      <create-ship-modal @afterSave="closeShipModal" @close="closeShip" ref="modalShip"></create-ship-modal>
    </vxe-modal>
  </div>
</template>

<script>
import $api from '@/apiProvider'
import getAuthOrization from "@/mixin/getAuthOrization";
import CreateCarModal from "@/views/carShip/CreateCarModal";
import CreateShipModal from "@/views/carShip/CreateShipModal";

export default {
  name: "CarShip",
  components: {CreateShipModal, CreateCarModal},
  mixins: [getAuthOrization],
  data() {
    return {
      selectTab: "tab1",
      name: null,
      mmsi: null,
      shipData: [],
      carData: [],
      loading1: false,
      loading2: false,
      dict: [],
      page1: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      page2: {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      },
      type: null,
      createCarVisible: false,
      createShipVisible: false,
    };
  },
  created() {

  },
  methods: {
    showCarModal() {
      this.createCarVisible = true;
      this.$refs.modalCar.showUpdate();
    },
    closeCarModal(type) {
      this.createCarVisible = false;
      if (type === 'afterSave') {
        this.search();
      }
    },
    closeCar() {
      this.$refs.modalCar.reset();
    },
    showShipModal() {
      this.createShipVisible = true;
      this.$nextTick(() => {
        this.$refs.modalShip.showUpdate();
      })
    },
    closeShipModal() {
      this.search();
      this.createShipVisible = false;
    },
    closeShip() {
      this.$refs.modalShip.reset();
    },
    async getDict() {
      let res = await $api.dict.get("searchDic");
      if (res.status === 1) {
        this.dict = res.data;
        this.queryShipList();
        this.queryCarList();
      } else {
        this.$XModal.message(res.message);
      }
    },
    changePage1(e) {
      this.page1.currentPage = e.currentPage;
      this.page1.pageSize = e.pageSize;
      this.queryShipList();
    },
    changePage2(e) {
      this.page2.currentPage = e.currentPage;
      this.page2.pageSize = e.pageSize;
      this.queryCarList();
    },
    currentChangeEvent1({row}) {
      this.$emit("choose", row, 'ship');
    },
    currentChangeEvent2({row}) {
      this.$emit("choose", row, 'car');
    },
    search() {
      if (this.selectTab === "tab1") {
        this.page1.currentPage = 1;
        this.page1.pageSize = 10;
        this.queryShipList();
      } else {
        this.page2.currentPage = 1;
        this.page2.pageSize = 10;
        this.queryCarList();
      }
    },
    init(type) {
      this.type = type
      if (type) {
        this.selectTab = type === 1 || type === 4 ? "tab1" : "tab2";
      }
      this.page1 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.page2 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.name = null;
      this.mmsi = null;
      this.getDict();
    },
    async queryShipList() {
      this.loading1 = true;
      let res = await $api.carShip.request('queryShipListSelect', {
        shipName: this.name,
        orderBy: 2,
        page: this.page1.currentPage,
        rows: this.page1.pageSize,
        mmsi: this.mmsi,
        sourceType: 1,
      });
      if (res.status === 1) {
        this.page1.totalResult = res.data.total;
        let data = res.data.rows;
        let dict = this.dict;
        data.map(i => {
          if (i.homePort) {
            let homePortList = i.homePort.split(',');
            i.homePort = homePortList;
            let homePort = '';
            dict.map(i => {
              if (parseInt(homePortList[1]) === i.dictCode && parseInt(homePortList[0]) === i.dictCodeP) {
                homePort = i.dictText
              }
            })
            i.homePortText = homePort;
          }
        })
        this.shipData = data;
        this.loading1 = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    async queryCarList() {
      this.loading2 = true;
      let res = await $api.carShip.request('queryCarListSelect', {
        carNum: this.name,
        orderBy: 2,
        page: this.page2.currentPage,
        rows: this.page2.pageSize,
        sourceType: 1,
      });
      if (res.status === 1) {
        this.page2.totalResult = res.data.total;
        let data = res.data.rows;
        let dict = this.dict;
        data.map(i => {
          if (i.carTypeText) {
            let carTypeList = i.carTypeText.split(',');
            i.carTypeText = carTypeList;
            let carType = '';
            dict.map(i => {
              if (parseInt(carTypeList[1]) === i.dictCode) {
                carType = i.dictText
              }
            })
            i.carType = carType;
          }
          if (i.carNumColor) {
            dict.map(j => {
              if (i.carNumColor === j.dictCode) {
                i.carColor = j.dictText;
              }
            })
          }
        })
        this.carData = data;
        this.loading2 = false;
      } else {
        this.$XModal.alert({
          message: res.message ? res.message : "接口异常",
          status: "error",
        });
      }
    },
    close() {
      this.selectTab = "tab1";
      this.name = null;
      this.page1 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.page2 = {
        currentPage: 1,
        pageSize: 10,
        totalResult: 100,
      };
      this.$refs.xTable1.clearCurrentRow();
      this.$refs.xTable2.clearCurrentRow();
    }
  },
};
</script>

<style>
.createCarShipModal >>> .vxe-modal--box .vxe-modal--body {
  padding: .6em 1em !important;
  background: none !important;
}
</style>